import React from "react";
import { Box, Typography, Button, Card, CardContent } from "@mui/material";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import { motion } from "framer-motion";



const TopSellerPlants: React.FC = () => {
  return (
    <Box sx={{ padding: 4 }}>
      {/* <Typography
        variant="h4"
        sx={{
          fontFamily: "Satoshi, sans-serif",
          textAlign: "center",
          textTransform: "uppercase",
          fontSize: "12px",
          fontWeight: "700",
          lineHeight: " 100%",
          mb: 1,
        }}
      >
        Collection
      </Typography> */}
      {/* <Typography
        variant="h3"
        sx={{
          textAlign: "center",
          fontWeight: "300",
          lineHeight: "100%",
          mb: 4,
          fontSize: " 30px",
        }}
      >
        Our Products
      </Typography> */}
      {/* <Carousel products={topSeller} /> */}
    </Box>
  );
};

export default TopSellerPlants;
